import { NgModule } from "@angular/core";
import { IonicModule } from "ionic-angular";
import { TranslateModule } from "@ngx-translate/core";
import { HttpClientModule } from "@angular/common/http";
import { Avatar } from "./ui-components/avatar/avatar";
import { DecoratedAvatar } from "./ui-components/avatar/decorated-avatar";
import { Button } from "./ui-components/button/button";
import { Badge } from "./ui-components/badge/badge";
import { TypeBadge } from "./ui-components/badge/type-badge";
import { StatusBadge } from "./ui-components/badge/status-badge";
import { CodeField } from "./ui-components/text/code-field";
import { Searchbox } from "./ui-components/text/searchbox";
import { Textfield } from "./ui-components/text/textfield";
import { NumberBadge } from "./ui-components/badge/number-badge";
import { IconLink } from "./ui-components/button/icon-link";
import { Spinner } from "./ui-components/spinner/spinner";
import { SpinnerXl } from "./ui-components/spinner/spinner-xl";
import { Priority } from "./ui-components/priority/priority";
import { DatePicker } from "./ui-components/datetime/date-picker";
import { Switch } from "./ui-components/check/switch";
import { Checkbox } from "./ui-components/check/checkbox";
import { Upload } from "./ui-components/upload/upload";
import { UploadViewer } from "./ui-components/upload/upload-viewer";
import { Conversation } from "./ui/chat/conversation/conversation";
import { VisualComposer } from "./ui/chat/visual-composer";
import { Conversations } from "./ui/chat/conversation/conversations";
import { Message } from "./ui/chat/message/message";
import { Messages } from "./ui/chat/message/messages";
import { Welcome } from "./ui/chat/welcome/welcome";
import { SignIn } from "./ui/sign/sign-in";
import { SignInInfo } from "./ui/sign/sign-in-info";
import { SignUp } from "./ui/sign/sign-up";
import { Register } from "./ui/sign/register";
import { UserProfile } from "./ui/sign/user-profile";
import { ResetPassword } from "./ui/sign/reset-password";
import { BoxContainer } from "./ui-components/container/box-container";
import { MyTodo } from "./ui/my-todo/my-todo";
import { CreationForm } from "./ui/creation-form/creation-form";
import { TypingIndicator } from "./ui-components/typing-indicator/typing-indicator";
import { AccordionItem } from "./ui-components/accordion/accordion-item";
import { AccordionConversations } from "./ui/chat/conversation/accordion-conversations";
import { AccordionConversationHeader } from "./ui/chat/conversation/accordion-conversation-header";
import { Tabs } from "./ui-components/tabs/tabs";
var UiModule = /** @class */ (function () {
    function UiModule() {
    }
    UiModule.forRoot = function (config) {
        return {
            ngModule: UiModule,
            providers: [
                { provide: "config", useValue: config }
            ]
        };
    };
    UiModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        IonicModule,
                        HttpClientModule,
                        TranslateModule
                    ],
                    declarations: [
                        AccordionItem,
                        Avatar,
                        DecoratedAvatar,
                        Button,
                        IconLink,
                        Upload,
                        UploadViewer,
                        Spinner,
                        SpinnerXl,
                        Checkbox,
                        Switch,
                        DatePicker,
                        Priority,
                        Badge,
                        NumberBadge,
                        StatusBadge,
                        TypeBadge,
                        Searchbox,
                        CodeField,
                        Textfield,
                        BoxContainer,
                        TypingIndicator,
                        Tabs,
                        Conversation,
                        AccordionConversations,
                        AccordionConversationHeader,
                        Conversations,
                        Message,
                        Messages,
                        Welcome,
                        VisualComposer,
                        SignIn,
                        SignInInfo,
                        SignUp,
                        Register,
                        ResetPassword,
                        UserProfile,
                        MyTodo,
                        CreationForm
                    ],
                    exports: [
                        AccordionItem,
                        Avatar,
                        DecoratedAvatar,
                        Button,
                        IconLink,
                        Upload,
                        UploadViewer,
                        Spinner,
                        SpinnerXl,
                        Checkbox,
                        Switch,
                        DatePicker,
                        Priority,
                        Badge,
                        NumberBadge,
                        StatusBadge,
                        TypeBadge,
                        Searchbox,
                        CodeField,
                        Textfield,
                        BoxContainer,
                        TypingIndicator,
                        Tabs,
                        Conversation,
                        AccordionConversations,
                        AccordionConversationHeader,
                        Conversations,
                        Message,
                        Messages,
                        Welcome,
                        VisualComposer,
                        SignIn,
                        SignUp,
                        Register,
                        ResetPassword,
                        UserProfile,
                        MyTodo,
                        CreationForm
                    ]
                },] },
    ];
    return UiModule;
}());
export { UiModule };
//# sourceMappingURL=ui.module.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui.module.js
// module id = 977
// module chunks = 14